<template>
  <div>
    <!-- Header -->
    <Header
        headerTitle="获取离场凭证"
        :hasBackBtn="true"
        :rightIconSrc="require('../assets/img/dianhua.png')"
        :iconShow="true"
    ></Header>

    <div class="main-container" style="padding-top:5px">
      <div class="cardId">
        <h6>{{result.licenseplate}}</h6>
      </div>
      <div class="cardAddress">
        <h6>{{result.parkingName}}</h6>
        <p style="width:100%">{{result.parkingAddress}}</p>
      </div>
      <div class="money">
        <p>
          {{$t('m.overtimeOrder.inTime')}}
          <span>{{result.actualInTime}}</span>
        </p>
      </div>
      <div class="money">
        <p>
          {{$t('m.overtimeOrder.outTime')}}
          <span>{{result.actualOutTime}}</span>
        </p>
      </div>
      <div class="money">
        <p>
          {{$t('m.overtimeOrder.dateAndMoney')}}
          <span>{{result.appointTime/60}} {{$t('m.overtimeOrder.hours')}} | {{result.amount}} {{$t('m.overtimeOrder.CNY')}}</span>
        </p>
      </div>
      <div class="money">
        <p>
          {{$t('m.overtimeOrder.overTimeMoneyTitle')}}
          <img src="../assets/img/gantan.png" width="14">
          <span
              style="color:#0066B1;font-size:12px"
          >{{$t('m.overtimeOrder.overTime')}}{{(result.timeoutTime/60).toFixed(2)}} {{$t('m.overtimeOrder.hours')}} | {{result.timeoutAmount}}{{$t('m.overtimeOrder.CNY')}}</span>
        </p>
      </div>
      <div v-if="result.entranceWay == 1" >
        <p style=" font-size: 13px;color: #666;text-align: left;">温馨提示:
          获取凭证后请在15分钟内驶离停车场</p>
      </div>
      <footer>
        <b-btn variant="primary"
               v-b-modal.leave-disperser-modal
               style="width:100%;line-height:30px;"
        >获取离场凭证
        </b-btn>
        <b-modal
            hide-header
            id="leave-disperser-modal"
            class="cancelOrders"
            ok-title="确认"
            cancel-title="取消"
            @ok="gotoLeaveVoucher()"
        >
          <p class="my-4"
             style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >温馨提示</p>
          <p class="my-4"
             style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >请在停车结束后到达领取出场凭证</p>
        </b-modal>
      </footer>
    </div>
  </div>
</template>
<script>
  import {orderListByDetails} from "../api/order.js"

  export default {
    name: "LeaveVoucher",
    data() {
      return {
        result: {}, //数据
        orderId: "", //订单Id
        phone: "400-115-0606", //电话
      };
    },
    methods: {
      loadOrderOvertime() {
        //数据方法
        orderListByDetails({orderId: this.orderId}).then(response => {
          if (response.data.status == 200) {
            this.result = response.data.result;
          }
        });
      },
      gotoLeaveVoucher() {
        this.$router.push("/leaveVoucher/" + this.orderId);
      }
    },
    //加载事件
    created() {
      this.orderId = this.$route.params.orderId; //订单Id
      this.loadOrderOvertime();
    }
  };
</script>

<style>
  header,
  section p {
    margin: 0 auto;
    padding: 0;
  }

  header {
    text-align: center;
    font-size: 19px;
    color: black;
    padding: 10px;
    padding-bottom: 5px;
  }

  header .return {
    display: inline-block;
    float: left;
    vertical-align: middle;
    font-size: 14px;
  }

  header .title {
    text-align: center;
  }

  header .imgIco {
    display: inline-block;
    float: right;
  }

  section {
    margin-bottom: 50px;
  }

  section .cardId {
    border-bottom: 2px solid #efefef;
    padding: 5px 0;

    text-align: left;
  }

  section .cardId h6 {
    font-size: 14px;
    display: inline-block;
  }

  section .cardAddress {
    padding: 10px 0;
    text-align: left;
    border-bottom: 2px solid #efefef;
  }

  section .cardAddress h6 {
    margin: 0 auto;
    padding: 0px;
    font-size: 14px;
  }

  section .cardAddress p {
    font-size: 13px;
    color: #666;
    font-size: 11px;
  }

  .cancelOrders .modal {
    top: auto !important;
    bottom: 40% !important;
    margin: 0 10%;
  }

  .cancelOrders .modal .modal-dialog .modal-body {
    margin: 0px;
    padding: 0px;
  }

  .cancelOrders .modal .modal-dialog .modal-body .my-4 {
    font-size: 20px;
    color: #666;
  }

  .cancelOrders header {
    padding: 0px;
  }

  .cancelOrders .modal-footer {
    margin-left: 0px;
  }

  .cancelOrders footer {
    text-align: center;
  }

  footer .btn-primary {
    color: #fff;
    background-color: #0066B1;
    width: 100%;
    /* line-height: 30px; */
  }
</style>


